import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollSmoother } from 'gsap/ScrollSmoother.js';

export default class Scroller {
  constructor(element) {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    this.options = {
      hasSkew: false,
    };
    this.element = element;

    this.setOptions();
    this.init();
  }

  init() {
    const scroller = ScrollSmoother.create({
      smooth: 1,
      effects: true,
      smoothTouch: 0.1,
      ease: 'expo.out',
      onUpdate: this.onUpdateScroll.bind(this),
      onStop: this.onStopScroll.bind(this),
    });
  }

  onUpdateScroll(self) {
    if (this.options.hasSkew) {
      this.updateSkew(self);
    }
  }

  onStopScroll(self) {
    if (this.options.hasSkew) {
      this.stopSkew(self);
    }
  }

  // skew controls
  initSkew() {
    this.skewSetter = gsap.quickTo('img', 'skewY');
    this.skewSetter(5);
  }

  updateSkew(self) {
    const velocity = self.getVelocity();
    const force = 5;
    let skew = gsap.utils.mapRange(-1000, 1000, -force, force, velocity);
    skew = gsap.utils.clamp(-force, force, skew);

    this.skewSetter(skew);
  }

  stopSkew() {
    this.skewSetter(0);
  }

  //pin controls
  initPins() {
    const pinnedItems = this.element.querySelectorAll('.js-pinned');
    for (let i = 0; i < pinnedItems.length; i++) {
      const pinnedItem = pinnedItems[i];

      ScrollTrigger.create({
        pin: pinnedItem,
        trigger: pinnedItem.parentElement,
        start: 'center center',
        end: '80% center',
      });
    }
  }

  //section horiz
  initHoriz() {
    const sectionHoriz = this.element.querySelector('.js-horiz');
    const panels = sectionHoriz.querySelectorAll('.js-panel');
    const nbPanels = panels.length - 1;
    const buffer = 200;

    gsap.to(panels, {
      xPercent: -100 * nbPanels,
      ease: 'none',
      scrollTrigger: {
        pin: true,
        trigger: sectionHoriz,
        scrub: 1,
        snap: 1 / nbPanels,
        end: () => '+=' + (sectionHoriz.offsetWidth + buffer),
      },
    });
  }

  setOptions() {
    if ('skew' in this.element.dataset) {
      this.options.hasSkew = true;
      this.initSkew();
    }

    if ('pinItems' in this.element.dataset) {
      this.options.hasPinItems = true;
      this.initPins();
    }

    if (this.element.querySelector('.js-horiz')) {
      this.initHoriz();
    }
  }
}
